import React, { useState, useEffect } from 'react'

import { getRelativeBasePath } from '../../global/environments/path'

export default function DisclosureModal() {
  const STORAGE_KEY = 'CM_Institutional_Disclaimer'
  const CTI_URL = 'https://www.columbiathreadneedleus.com/'

  const EXPIRY_TIME = 60 * 60 * 24 * 30 // 30 days in seconds

  const [showModal, setShowModal] = useState(false)
  const [privateCheckSelected, setPrivateCheckSelected] = useState(true)

  useEffect(() => {
    let disclaimerAccepted

    try {
      disclaimerAccepted =
        window.sessionStorage.getItem(STORAGE_KEY) ||
        new Date().getTime() <= window.localStorage.getItem(STORAGE_KEY)
    } catch (e) {
      console.error('Error accessing storage for disclaimer:', e)
    }

    if (!disclaimerAccepted && window.location === window.parent.location) {
      setShowModal(true)
    }
  }, [])

  const handleCheck = () => {
    setPrivateCheckSelected(!privateCheckSelected)
  }

  const handleClick = () => {
    try {
      if (privateCheckSelected) {
        window.sessionStorage.removeItem(STORAGE_KEY)
        window.localStorage.setItem(
          STORAGE_KEY,
          new Date().getTime() + 1000 * EXPIRY_TIME
        )
      } else {
        window.localStorage.removeItem(STORAGE_KEY)
        window.sessionStorage.setItem(STORAGE_KEY, true)
      }
    } catch (e) {
      console.error('Error setting disclaimer in storage:', e)
    }

    setShowModal(false)
    return false
  }

  return (
    showModal && (
      <div id="disclosure-modal-react-app">
        <div className="Modal">
          <dialog className="Modal-window">
            <div className="Modal-content">
              <h3 className="u-marginBottom5gu">
                Welcome to the Columbia Threadneedle Investments U.S.
                Institutional Website
              </h3>
              <p>
                <span className="u-textBold">
                  This site is exclusively intended for institutional investors
                  and consultants.
                </span>
                Columbia Management Investment Advisers, LLC (CMIA) offers asset
                management and investment advisory services to institutional
                investors through various strategies and investment vehicles. If
                you are not an institutional investor or consultant or would
                like information on our retail mutual funds, please visit&nbsp;
                <a href={CTI_URL}>columbiathreadneedleus.com</a>
                &nbsp;to select our websites for individual investors or
                financial professionals.
              </p>
              <p>
                This site is for informational purposes and does not constitute
                an offer to sell or provide a solicitation of an offer to buy
                any security that may be referenced. The information contained
                on this site does not, in any way, constitute investment advice.
              </p>
              <p>
                <span className="u-textBold">
                  This site is intended for U.S. residents only.&nbsp;
                </span>
                Please read the&nbsp;
                <a href={getRelativeBasePath() + '/user-agreement'}>
                  User Agreement
                </a>
                &nbsp;carefully before proceeding. The use of this website is
                governed by Minnesota state law and applicable federal U.S. law.
                It is not directed to any person in any jurisdiction where the
                publication or availability of the website is prohibited.
              </p>
              <p>
                By selecting <span className="u-textBold">I accept</span> below,
                I agree to be bound by the user agreement set forth on this
                website. CMIA reserves the right to change the terms and
                conditions at any time.
              </p>
              <input
                className="u-marginTop4gu"
                type="checkbox"
                id="private-check"
                name="private-check"
                checked={privateCheckSelected}
                onChange={handleCheck}
              />
              <label className="u-textPrimary" htmlFor="private-check">
                {' '}
                I am using a private computer or device.
              </label>
            </div>
            <footer className="Modal-footer">
              <div className="ButtonRow">
                <a
                  className="Link Button--small u-textCenter u-textSecondary"
                  href={getRelativeBasePath() + '/investor-redirect'}
                >
                  I DO NOT ACCEPT
                </a>
                <button
                  id="disclaimer-accept-button"
                  className="Button Button--primary Button--small u-sm-marginTop2gu u-md-marginRight4gu u-md-marginTop2gu"
                  onClick={handleClick}
                >
                  I accept
                </button>
              </div>
            </footer>
          </dialog>
        </div>
      </div>
    )
  )
}
